class ElectrodeApp {
    constructor() {
        this.currentFilter = 'all';
        this.isMobile = window.innerWidth < 768;
        this.init();
        this.bindResizeListener();
    }

    init() {
        if (document.querySelectorAll('.electrode-container').length === 0) {
            return;
        }
        this.bindEvents();
        this.showAllImages();
        this.setupInitialState();
    }

    setupInitialState() {
        // On desktop, expand all categories by default
        if (!this.isMobile) {
            const expandableItems = document.querySelectorAll('.expandable');
            expandableItems.forEach(item => {
                item.classList.add('active');
                const icon = item.querySelector('.toggle-icon');
                if (icon) {
                    icon.textContent = '−';
                }
            });
        }
    }

    bindResizeListener() {
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                const wasMobile = this.isMobile;
                this.isMobile = window.innerWidth < 768;

                if (wasMobile !== this.isMobile) {
                    this.handleResponsiveChange();
                }
            }, 250);
        });
    }

    handleResponsiveChange() {
        const toggleMenu = document.getElementById('toggleMenu');
        const symptomsMenu = document.getElementById('symptomsMenu');

        if (this.isMobile) {
            // Switching to mobile
            this.closeMainMenu(toggleMenu, symptomsMenu);
            this.collapseAllCategories();
        } else {
            // Switching to desktop
            symptomsMenu.classList.remove('active');
            toggleMenu.classList.remove('active');
            this.expandAllCategories();
        }
    }

    expandAllCategories() {
        const expandableItems = document.querySelectorAll('.expandable');
        expandableItems.forEach(item => {
            item.classList.add('active');
            const icon = item.querySelector('.toggle-icon');
            if (icon) {
                icon.textContent = '−';
            }
        });
    }

    collapseAllCategories() {
        const expandableItems = document.querySelectorAll('.expandable');
        expandableItems.forEach(item => {
            item.classList.remove('active');
            const icon = item.querySelector('.toggle-icon');
            if (icon) {
                icon.textContent = '+';
            }
        });
    }

    bindEvents() {
        const toggleMenu = document.getElementById('electrodeToggleMenu');
        const symptomsMenu = document.getElementById('symptomsMenu');
        const menuButtons = document.querySelectorAll('.menu-button');
        const categoryToggles = document.querySelectorAll('.category-toggle');

        // Mobile menu toggle
        toggleMenu.addEventListener('click', () => {
            if (this.isMobile) {
                this.toggleMainMenu(toggleMenu, symptomsMenu);
            }
        });

        // Symptom button clicks
        menuButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const electrodeIds = button.getAttribute('data-el');
                const symptomText = button.textContent.trim();
                this.filterImages(electrodeIds, symptomText, button);

                // Close mobile menu after selection
                if (this.isMobile) {
                    this.closeMainMenu(toggleMenu, symptomsMenu);
                }
            });
        });

        // Category toggle clicks
        categoryToggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleCategory(toggle);
            });
        });

        // Close mobile menu when clicking outside (mobile only)
        document.addEventListener('click', (e) => {
            if (this.isMobile &&
                !symptomsMenu.contains(e.target) &&
                !toggleMenu.contains(e.target) &&
                symptomsMenu.classList.contains('active')) {
                this.closeMainMenu(toggleMenu, symptomsMenu);
            }
        });

        // Prevent menu from closing when clicking inside
        symptomsMenu.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    }

    toggleMainMenu(toggleButton, menu) {
        if (!this.isMobile) return;

        const isActive = menu.classList.contains('active');

        if (isActive) {
            this.closeMainMenu(toggleButton, menu);
        } else {
            this.openMainMenu(toggleButton, menu);
        }
    }

    openMainMenu(toggleButton, menu) {
        toggleButton.classList.add('active');
        menu.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    closeMainMenu(toggleButton, menu) {
        toggleButton.classList.remove('active');
        menu.classList.remove('active');
        document.body.style.overflow = '';
    }

    toggleCategory(toggleButton) {
        const expandableItem = toggleButton.parentElement;
        const isActive = expandableItem.classList.contains('active');

        expandableItem.classList.toggle('active');

        const icon = toggleButton.querySelector('.toggle-icon');
        if (icon) {
            icon.textContent = isActive ? '+' : '−';
        }
    }

    filterImages(electrodeIds, symptomText, clickedButton) {
        const selectedSymptom = document.getElementById('selectedSymptom');
        const allImages = document.querySelectorAll('.electrode-image');
        const menuButtons = document.querySelectorAll('.menu-button');

        // Update selected state
        menuButtons.forEach(btn => btn.classList.remove('selected'));
        clickedButton.classList.add('selected');

        // Update selected symptom display
        selectedSymptom.textContent = symptomText;

        // Show all images if "Tutti" is selected or no specific filter
        if (!electrodeIds || electrodeIds.includes('01,02,03,04,05,06,07,08,09,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64')) {
            this.showAllImages();
            return;
        }

        // Filter images based on electrode IDs
        const targetIds = electrodeIds.split(',').map(id => id.trim().padStart(2, '0'));

        allImages.forEach(img => {
            const imgId = img.id.replace('im-', '');
            const shouldShow = targetIds.includes(imgId);

            if (shouldShow) {
                img.classList.remove('hidden');
                img.style.animation = 'fadeIn 0.3s ease';
            } else {
                img.classList.add('hidden');
            }
        });

        // Scroll to images on mobile
        if (this.isMobile) {
            this.scrollToImages();
        }
    }

    showAllImages() {
        const allImages = document.querySelectorAll('.electrode-image');
        const selectedSymptom = document.getElementById('selectedSymptom');

        allImages.forEach(img => {
            img.classList.remove('hidden');
            img.style.animation = 'fadeIn 0.3s ease';
        });

        selectedSymptom.textContent = 'Tutti';
    }

    scrollToImages() {
        const imagesContainer = document.getElementById('imagesContainer');
        const offsetTop = window.scrollY + imagesContainer.getBoundingClientRect().top - 165 - document.getElementById('symptomsMenu').getBoundingClientRect().height; // 100px offset

        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
        document.querySelectorAll('.shopify-section-header-sticky').forEach(el => {
            el.classList.remove('shopify-section-header-hidden')
        })

        undefined
    }
}

// Initialize the app when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new ElectrodeApp();
});

// Utility function for smooth height transitions
function slideDown(element, duration = 300) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;

    let height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    element.offsetHeight;
    element.style.boxSizing = 'border-box';
    element.style.transitionProperty = "height, margin, padding";
    element.style.transitionDuration = duration + 'ms';
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');

    window.setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
    }, duration);
}

function slideUp(element, duration = 300) {
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = duration + 'ms';
    element.style.boxSizing = 'border-box';
    element.style.height = element.offsetHeight + 'px';
    element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;

    window.setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
    }, duration);
}
